import { ROLES } from '@/constants/roles';

const routes = [
  {
    path: '/events/owner-exchange/view/:id',
    name: 'events-owner-exchange-view-id',
    component: () => import('./views/OwnerExchangeEvent/index.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/events/owner-exchange',
    name: 'events/owner-exchange',
    component: () => import('./views/OwnerExchangeEvents/index.vue'),
    meta: {
      accessList: [ROLES.organization],
    },
  },
];

export default routes;
